import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dayjs from 'vue-dayjs'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueMeta from 'vue-meta';

import {url} from './global/index';

Vue.use(dayjs)
Vue.use(VueAxios, axios)
Vue.use(VueMeta);
axios.defaults.baseURL = url;
axios.defaults.timeout = 5000;

Vue.config.productionTip = false

// Swiper lazy-load — only register when a swiper-using component mounts
let swiperRegistered = false;
window.__registerSwiper = async () => {
  if (swiperRegistered) return;
  swiperRegistered = true;
  const { register } = await import(/* webpackChunkName: "swiper-bundle" */ 'swiper/element/bundle');
  register();
};

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'));
  }
}).$mount('#app')
